import React from 'react';

interface HighlightedTextProps {
  readonly text: string;
  readonly indices?: ReadonlyArray<readonly [number, number]>;
}

export const HighlightedText: React.FC<HighlightedTextProps> = (
  props: HighlightedTextProps,
): React.ReactElement => {
  const { text, indices = [] } = props;

  if (!indices.length) {
    return <>{text}</>;
  }

  const parts: React.ReactNode[] = [];
  let lastIndex = 0;

  // Sort indices by start position
  const sortedIndices = [...indices].sort(
    (a: readonly [number, number], b: readonly [number, number]): number => a[0] - b[0],
  );

  sortedIndices.forEach(([start, end]: readonly [number, number], i: number): void => {
    // Add text before match
    if (start > lastIndex) {
      parts.push(text.slice(lastIndex, start));
    }
    // Add highlighted match
    parts.push(
      <span
        key={i}
        style={{
          backgroundColor: 'rgba(255, 213, 0, 0.3)',
          borderRadius: '2px',
          fontStyle: 'inherit',
          fontWeight: 'inherit',
          fontFamily: 'inherit',
        }}>
        {text.slice(start, end + 1)}
      </span>,
    );
    lastIndex = end + 1;
  });

  // Add remaining text after last match
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return <>{parts}</>;
};
